import React from "react";
import styled from "styled-components";
import { Grid, Segment } from "semantic-ui-react";
import Background from "Home/components/Background";
import LegalFooter from "Home/components/LegalFooter";
const LogoHeader = styled.div `
  background-color: #afefff;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  border-radius: 15px 15px 0 0;
`;
const LogoImage = styled.img `
  height: 45px;
  width: auto;
`;
const AuthFormLayout = ({ children, showBottomSection = false, bottomSection, }) => {
    return (React.createElement(Background, null,
        React.createElement(Grid, { textAlign: "center", style: { margin: "0", flex: 1 } },
            React.createElement(Grid.Column, { style: {
                    maxWidth: 450,
                    width: "100%",
                    overflowY: "auto",
                } },
                React.createElement(LogoHeader, null,
                    React.createElement(LogoImage, { src: "/logo_exfluency.svg", alt: "exfluency" })),
                React.createElement(Segment, { style: {
                        borderRadius: "0 0 15px 15px",
                        margin: "0",
                        padding: "0",
                        border: "none",
                    } },
                    React.createElement(Segment, { textAlign: "left", style: {
                            borderRadius: showBottomSection ? "0px" : "0 0 15px 15px",
                            boxShadow: "none",
                            margin: "0",
                            overflowY: "auto",
                        } }, children),
                    showBottomSection && bottomSection))),
        React.createElement(LegalFooter, null)));
};
export default AuthFormLayout;
